import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class TrackingCodeService {
  constructor(private httpClient: HttpClient) {
  }

  getTrackingCode(){
    return this.httpClient.get<{trackingCode: string}>('servlets/auth/trackingcode/');
  }
}
